import Box from '@mui/material/Box';
import { FormCheckBox, useTrackedFormik } from '@omnigenbiodata/ui';
import * as yup from 'yup';
import { useTranslation } from 'react-i18next';
import { StepProps } from '../../../../core/types/common.types';
import EnrolmentStepContainer from '../EnrolmentStepContainer';

function Consent3Step({ currentStep, onStepForward, onStepBack, values }: StepProps) {
  const { t } = useTranslation('portal');

  const validationSchema = yup.object().shape({
    consent3: yup
      .boolean()
      .required(t('forms.consent3.msg.required') as string)
      .oneOf([true], t('forms.consent3.msg.required') as string),
  });

  const formik = useTrackedFormik(
    {
      initialValues: { consent3: false, ...values },
      validationSchema,
      onSubmit: (values: any) => {
        onStepForward(values);
      },
    },
    'consent3',
  );

  return (
    <EnrolmentStepContainer
      onSubmit={formik.handleSubmit}
      title={t('enrol.consent3.title')}
      text={t('enrol.consent3.text') as string}
      onBack={onStepBack}
      showBack={currentStep > 0}
    >
      <Box mb={4} px={{ xs: 3, sm: 0 }}>
        <FormCheckBox
          error={formik.errors.consent3}
          name="consent3"
          label={t('forms.consent3.label')}
          onChange={formik.handleChange}
          touched={formik.touched.consent3}
          value={formik.values.consent3}
        />
      </Box>
    </EnrolmentStepContainer>
  );
}

export default Consent3Step;
